import pushNotification from "@apis/pushNotification";
import {
  deletesvg,
  edit,
  outlinenotification,
  resend,
  switchOff,
  switchOn,
} from "@assets/icons";
import Svg from "@components/svg";
import Table from "@components/table";
import Wrapper from "@components/wrapper";
import useConfig from "@hooks/useConfig";
import useScrollToTop from "@hooks/useScrollToTop";
import { RootState } from "@store/index";
import { Helper } from "@utils/index";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotificationList = () => {
  const scrollToTop = useScrollToTop();
  const navigate = useNavigate();
  const {
    items: pushNotifications,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.pushNotification);
  const config = useConfig();
  const [page, setPage] = useState(1);
  const fetchPushNotifications = useCallback(async () => {
    try {
      await pushNotification.list({
        state: "pushNotification",
        params: { page, limit: 20 },
      });
    } catch (error) {}
  }, []);
  const columns = [
    { title: "SN", key: "sn", render: (_, i) => <p>{i + 1}</p> },
    { title: "Title", key: "title" },
    { title: "Target", key: "targetAudience", render: (item: any) => <p>{item.targetAudience?.toUpperCase()}</p> },
    { title: "Description", key: "description" },
    {
      title: "Image",
      key: "image",
      render: (item: any) => (
        <img
          src={
            item.image
              ? `${config.bucketUrl}/${item.image}`
              : "https://placehold.co/50"
          }
          alt="pushnotification"
          width={50}
        />
      ),
    },
    {
      title: "Resend",
      key: "resend",
      render: (item) => (
        <Svg
          src={resend}
          onClick={async () => {
            await pushNotification.resend({
              id: item.id,
            });
          }}
        />
      ),
    },
  ];

  const data = pushNotifications.map((pn) => ({
    id: pn.id,
    title: pn.title,
    description: pn.body,
    image: pn.image,
    targetAudience: pn.targetAudience,
  }));

  useEffect(() => {
    fetchPushNotifications();
  }, []);
  const user = Helper.getUser();
  return (
    <Fragment>
      <Wrapper>
        <Table
          loading={loading}
          searchKeys={["title"]}
          text="Notification List"
          columns={columns}
          data={data}
          pageControlled={page}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={setPage}
          actions={[
            {
              icon: edit,
              key: "edit",
              onClick: (item) => {
                navigate(`/${user.role}/push-notifications/${item.id}`, {
                  state: item,
                });
                scrollToTop();
              },
            },
          ]}
        />
      </Wrapper>
    </Fragment>
  );
};

export default NotificationList;
